import { service } from '@ember/service';
import Controller from '@ember/controller';

export default class RequestClientTypeController extends Controller {
  @service currentPractice;
  @service session;
}
